import { Image } from "./styles";
import DialogAlert from "components/DialogAlert/v2";
import successImg from "../../img/success_img.svg";
import { Container, Content, Footer } from "../styles";

const DialogAlertSuccessNotify = ({
    dialog, buttons, variant,
    title, subtitle, 
    description, contentComponent
}) => {
    return (
        <DialogAlert dialog={dialog}>
            <Container>
                <Content>
                    <Image src={successImg} alt="Imagen de creación de evento exitoso UTP"/>
                    <h3 className={variant}>{title}</h3>
                    {subtitle && <h4>{subtitle}</h4>}
                    {contentComponent && contentComponent}
                    {description && <p>{description}</p>}
                </Content>
                <Footer>
                    {buttons}
                </Footer>
            </Container>
        </DialogAlert>
    );
}

export default DialogAlertSuccessNotify;